<template>
  <div>
    <div class="main_visual">
      <div class="header_wrap">
        <header>
          <div class="logo">
            <h1>
              <a @click="goPage('hero')"
                ><img src="/static/seoul/img/logo.png" alt=""/></a
              ><span style="font-size:12pt; font-weight: bold;">{{
                loginUser
              }}</span
              ><span style="font-size:12pt; font-weight: 300; margin-left: 5px;"
                >({{ displayFullName }})</span
              >
            </h1>
            <button
              v-if="this.$store.state.user.authorize === 'a'"
              id="goDashboard"
              @click="goPage('dashboard')"
            >
              관리자
            </button>
          </div>
          <div class="r_menu">
            <ul class="top_left_menu">
              <li><a class="f-white" @click="goPage('hero')">홈</a></li>
              <li>
                <a class="f-white" @click="goPage('myMeeting')"
                  >진행중인 회의</a
                >
              </li>
              <li>
                <a class="f-white" @click="goPage('joinMeeting')">나의 회의</a>
              </li>

              <li><a @click="openManual()">매뉴얼</a></li>
            </ul>
          </div>
          <!-- r_menu -->
        </header>
      </div>
      <!-- //.header_wrap -->
    </div>
    <!-- <div class="header_wrap">
      <header>
        <div class="logo">
          <h1><a @click="goPage('hero')"><img src="/static/seoul/img/logo.png" alt=""></a> </h1>
        </div>
        <ul class="menu">
          <li><a class="f-white" @click="goPage('hero')">홈</a></li>
          <li><a class="f-white" @click="goPage('myMeeting')">진행중인 회의</a></li>
          <li><a class="f-white" @click="goPage('joinMeeting')">참여한 회의</a></li>
        </ul>

        <div class="r_userinfo">
          <a href="#">
            <span class="username f-white" @click="goPage('profile')">{{ $t('page-header.profile') }}</span>
            <img src="/static/seoul/img/main_top_user_info.png" alt="" @click="logout()">
          </a>
        </div>
        <div class="r_menu">
          <a class="f-white" style="line-height: 37px; float:left;">매뉴얼</a>
          <div @click="logout()">로그아웃</div>
        </div>
      </header>
    </div> -->
    <manual-dialog :dialog="manualDialog" :closeDialog="closeDialog" />

    <div style="position:absolute; margin-top:63.5px; width:100%;">
      <v-divider></v-divider>
    </div>
  </div>
</template>
<script>
import Util from "@/util";
import ManualDialog from "@/components/popup/ManualDialog";
import moment from "moment";
import timezone from "moment-timezone";
import pkg from "../../package";
import SlideUpDown from "vue-slide-up-down";

export default {
  name: "app-toolbar",
  components: {
    ManualDialog,
    SlideUpDown,
  },
  data: () => ({
    langs: [
      {
        locale: "kr",
        display: "한국어",
        imgSrc: "/static/images/kor.png",
        // 24x24
      },
      {
        locale: "en",
        display: "English",
        imgSrc: "/static/images/eng.png",
        // 24x24
      },
      // {
      //   locale: 'cn',
      //   display: 'Chinese',
      //   imgSrc: 'https://cdn.vuetifyjs.com/images/flags/cn.png'
      //   // 24x24
      // },
      // {
      //   locale: 'vn',
      //   display: 'Vietnam',
      //   imgSrc: 'https://flagcounter.com/images/flags/vn.png'
      //   // 16x11
      // },
      // {
      //   locale: 'sg',
      //   display: 'Singapore',
      //   imgSrc: 'https://flagcounter.com/images/flags/sg.png'
      //   // 16x11
      // }
    ],
    selectedLang: {},
    items: [
      // {
      //   icon: 'account_circle',
      //   href: '#',
      //   title: 'Profile',
      //   click: (e) => {
      //     window.getApp.$emit('APP_GO_PROFILE');
      //   }
      // },
      {
        icon: "fullscreen_exit",
        href: "#",
        title: "Logout",
        click: (e) => {
          window.getApp.$emit("APP_LOGOUT");
        },
      },
    ],
    noticeMsg: "",
    isNotice: false,
    manualDialog: false,
    interval: 5,
    webexHistory: {},
    useHidden: true,
    timing: "",
    duration: 500,
    active: false,
    loginUser: null,
    displayFullName: null,
    isAdmin: false,
  }),
  computed: {
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav;
    },
  },
  watch: {
    "$store.state.route.name": {
      handler(val) {
        if (val) {
          this.noticeSetting();
        }
      },
    },
  },
  created() {
    if (!Util.hasSession(this, true)) return;
    this.noticeSetting();
    this.start();
    this.selectedLang = this.langs.find(
      (lang) => lang.locale === this.$i18n.locale
    );
    if (pkg.isHanwha) {
      this.items.pop();
    }

    if (this.$store.state.user) {
      console.log(this.$store.state.user);
      this.loginUser = this.$store.state.user.username;
      this.displayFullName = this.$store.state.user.department;
      this.isAdmin = this.$store.state.user.authorize === "a" ? true : false;
    } else {
      this.loginUser = null;
      this.isAdmin = false;
    }
    this.selectedLang = this.$i18n.locale;
  },
  methods: {
    goHome() {
      if (this.$store.state.user) {
        this.$router.replace("/hero");
      }
    },
    goPage(page) {
      if (page === "external") {
        /* 외부망 */
        // alert('준비중입니다.');
        // alert('대시민용으로 이동합니다.');
        this.$window.location.href = "https://meet.eseoul.go.kr";
      } else {
        this.$router.replace("/" + page);
      }
      /*
      if (this.$route.path === '/' + page) {
        this.$router.go();
      } else {
        this.$router.replace('/' + page);
      }
      */
    },
    langMouseEnter() {
      this.active = true;
    },
    langMouseLeave() {
      this.active = false;
    },
    setLocale(lang) {
      this.selectedLang = lang;
      this.$i18n.locale = this.selectedLang; // this.selectedLang.locale;
      this.$store.dispatch("setLocale", this.$i18n.locale);
    },
    korVersion() {
      console.log("korVersion");
    },
    engVersion() {
      console.log("engVersion");
    },
    profile() {
      this.$router.push({ name: "Profile" });
    },
    personalAddress() {
      this.$router.push({ name: "PersonalAddress" });
    },
    logout() {
      window.getApp.$emit("APP_LOGOUT");
    },
    goAdminPage() {
      this.$router.push({ name: "Dashboard" });
    },
    async start() {
      let intervalMs = 5 * 60 * 1000; // 5분마다 새로고침
      this.interval = setInterval(() => {
        this.searchClick();
      }, intervalMs);
    },
    async searchClick() {
      let params = "";
      await this.$http
        .get("/api/v1/systems/history", { params: params })
        .then((response) => {
          let data = response.data;
          this.webexHistory = data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    async setHistory() {
      let params = {};
      if (this.webexHistory.actived === true) {
        return;
      }
      await this.$http
        .post("/api/v1/systems/history", params)
        .then((response) => {
          this.webexHistory.actived = response.data.webexHistory.actived;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    linkRssHistory() {
      this.$router.replace("/WebexHistory");
      this.setHistory();
    },
    handleDrawerToggle() {
      window.getApp.$emit("APP_DRAWER_TOGGLED");
    },
    handleFullScreen() {
      Util.toggleFullScreen();
    },
    async openManual() {
      console.log("openManual");
      // this.downloadMenual('manual1');
      this.manualDialog = true;
    },
    closeDialog() {
      this.manualDialog = false;
    },
    downloadMenual(num) {
      let file_path = "";
      switch (num) {
        case "manual1":
          file_path =
            "/static/seoul/manual/[내부직원] 서울시 영상회의 시스템 사용자 매뉴얼.pdf";
          break;
        case "manual2":
          file_path = "/static/seoul/manual/[내부직원] 동영상 매뉴얼.mp4";
          break;
      }

      let a = document.createElement("A");
      a.href = file_path;
      a.download = file_path.substr(file_path.lastIndexOf("/") + 1);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    async noticeSetting() {
      // Vue 오류로 주석
      // if (this.$store.state.user) {
      //   await this.$http.get('/api/v1/systems').then(response => {
      //     let settings = response.data;
      //     this.$store.dispatch('setSettings', settings);
      //   });
      //   if (this.$store.state.settings.systems.notice === '' || this.$store.state.settings.systems.notice === undefined) {
      //     this.noticeMsg = this.$t('page-header.notice-message', { name: this.$store.state.user.username });
      //   } else {
      //     if (moment() <= moment(this.$store.state.settings.systems.noticeDtime)) {
      //       this.noticeMsg = this.$store.state.settings.systems.notice;
      //       this.isNotice = true;
      //     }
      //     else {
      //       this.noticeMsg = this.$t('page-header.notice-message', { name: this.$store.state.user.username });
      //     }
      //   }
      // }
    },
  },
};
</script>

<style lang="stylus">
.notice-style {
  height: 64px;
  display: table;
  margin-left: 20px;
}

.notice-style i{
  display: table-cell;
  vertical-align: middle;
}

.notice-style span{
  display: table-cell;
  vertical-align: middle;
}
#goDashboard {
  position: absolute;
  top: 33px;
  left: 500px;
  padding: 8px 20px;
  border-radius: 50px;
  text-decoration: none;
  font-family: 'Noto Sans KR';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #fff;
  background: #076884;
}
</style>



// WEBPACK FOOTER //
// src/components/AppToolbar.vue